import styled, { css } from 'styled-components';
import { colors } from '../../utils/variables.styles';

const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['nested', 'click'].includes(prop)
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${colors.white};

  ${(props) => props.nested && css`
    background: ${colors.whiteer};
  `}
`;

export {
  Container
};
